/**
 * Goods receipting default date range is 40 days. An empty table in that
 * window is not “you have no orders” when the venue has POs outside it.
 */

export const GOODS_RECEIPTING_DEFAULT_RANGE_DAYS = 40
export const GOODS_RECEIPTING_WIDEN_RANGE_DAYS = 365

const MS_PER_DAY = 24 * 60 * 60 * 1000

export const GOODS_RECEIPTING_RANGE_EMPTY_COPY = Object.freeze({
  title: 'No deliveries in these dates',
  body: 'You have purchase orders outside this range. Widen the dates to see them.',
  ctaLabel: 'Show last 12 months',
})

export function getGoodsReceiptingRangeDays({ start, end } = {}) {
  const from = Number(start)
  const to = Number(end)
  if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) {
    return GOODS_RECEIPTING_DEFAULT_RANGE_DAYS
  }
  return Math.round((to - from) / MS_PER_DAY)
}

export function canWidenGoodsReceiptingRange(filterDates) {
  return (
    getGoodsReceiptingRangeDays(filterDates) < GOODS_RECEIPTING_WIDEN_RANGE_DAYS
  )
}

export function getWidenedGoodsReceiptingFilterDates(now = Date.now()) {
  const end = Number(now) || Date.now()
  return {
    start: end - GOODS_RECEIPTING_WIDEN_RANGE_DAYS * MS_PER_DAY,
    end,
  }
}

export function hasGoodsReceiptingPurchaseOrderHistory(ladder) {
  return Boolean(ladder?.signals?.hasPurchaseOrders)
}

/**
 * Range is empty, but Express says the venue has POs (receipted or not)
 * somewhere. Offer widen instead of first-try unused copy.
 */
export function shouldShowGoodsReceiptingRangeEmpty({
  orders,
  hasPurchaseOrders = false,
  canWiden = false,
  loading = false,
} = {}) {
  if (loading) return false
  if (!hasPurchaseOrders) return false
  if (!canWiden) return false
  return !Array.isArray(orders) || orders.length === 0
}
